<template>

  <div class="pontos-cadastro ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->

              <b-col cols="10">
                   <label for="select-regiao">Região</label>  

                <multiselect id="selecaoregiao" v-model="value_regiao"  required
                :options="regioes" 
                :multiple="true"                 
                :close-on-select="false" 
                :clear-on-select="true" 
                :preserve-search="true" placeholder="Região" label="regiao" track-by="regiao" name="regiao"
                :preselect-first="false">
                <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} status selecionado</span></template>
                </multiselect>                
              </b-col> 

              <b-col cols="1">
                <br>                 
                <b-button variant="primary" class="mr-2 mt-2" :disabled="carregando" @click="carregando = true,loadPonto()">
                  <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Carregar
                </b-button>                      
              </b-col>

              <b-col cols="1">
                <br>
                <b-button variant="warning" class="ml-5 mt-2" v-b-modal.modal-multi-1 @click="reset()">Novo</b-button>
              </b-col>

          </b-row>
    </b-form>

    
    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>    
    <!--tbl de dados -->
    <b-table id="regioes"  small hover striped sticky-header="550px"  :items="pontos" :fields="fields" >    
        <template slot="cell(actions)" slot-scope="data"  >
          <b-button  @click="editPonto(data.item)"    title="Editar Pontos"  size="sm" variant="primary" class="mr-2 mt-2" v-b-modal.modal-multi-1>                
            <i class="fa fa-exclamation-circle"></i>              
          </b-button> 
        </template>   
    </b-table>

      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <div>        
    <b-modal id="modal-multi-1"   hide-footer size="lg" title="Cadastro de Ponto">
          <!-- -->
          <div>

            <b-row>
              <b-col cols="9">
                <label for="input-live">Ponto</label>
                <b-form-input v-model="ponto.ponto" placeholder="Digite a descrição do ponto"></b-form-input>              
              </b-col>

              <b-col cols="3">
                <label for="input-regiao">Região</label>
                <div>                
                  <b-form-select                  
                    v-model="ponto.id_regiao"                                                     
                    :options="regioes"
                    class="mb-3 "
                    text-field="regiao"
                    >                
                  </b-form-select>
              </div>
            </b-col>                
          </b-row>  
          <input  id="id-ponto" type="hidden" v-model="ponto.id_ponto" />

          <b-row>
            <b-col cols="6">
              <label for="input-live">Latitude</label> 
              <b-form-input id="carro-chassi" v-model="ponto.latitude" placeholder="digite a Latitude ex: -23.46204014649391"></b-form-input>
            </b-col>

              <b-col cols="6">
                <label for="input-live">Longitude</label>
                <b-form-input id="placa" v-model="ponto.longitude" placeholder="digite a Longitude ex: -46.666305828174195"></b-form-input>              
              </b-col>
            </b-row>            
             <b-button class="mt-3" variant="success" block @click="postPonto(),reset()">Gravar</b-button>            
          </div>          
        </b-modal>
      </div>
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
  </div>  
</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment from 'moment'


export default {    
    name: 'Manutencaoponto',    

    data: function() {

        
      
        return {            
            mode: 'save',
            carregando: false,
            atualizando: false,   
                    
            regiao:{}, 
            regioes: [],   // [] lista            
            value_regiao:[],// [] lista 

            ponto:{}    ,
            pontos: [],

            selected: null,
            
            value_carro:'',
            value_motivo: '',
            value_pecas:'',
            value_observacoes:'',
            value_status:'',

            //value_carro:'',   

            
            
          //  barra_inicial: 0,         
          //  barra_limite: 300000,
            
            fields: [
                { key: 'id_ponto', label: 'Nº Ponto', sortable: true },     
                { key: 'ponto', label: 'Ponto', sortable: true },                 
                { key: 'latitude', label: 'Latitude', sortable: true },                
                { key: 'longitude', label: 'Longitude', sortable: true },                
                { key: 'coordenadas', label: 'Coordenadas', sortable: true },                
                { key: 'regiao', label: 'Região', sortable: true },                
                { key: 'dt_cadastro', label: 'Data Cadastro', sortable: true, formatter: (value, key, ponto) => {
                    return moment(ponto.dt_cadastro).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },
                { key: 'dt_atualizacao', label: 'Data atualização', sortable: true, formatter: (value, key, ponto) => {
                    return moment(ponto.dt_atualizacao).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },

                { key: 'actions', label: 'Ações' },                
            ]
        }        
    },

    components: {
        Multiselect
    },
    methods: {


        loadRegiao() {          
          const url = `${baseApiUrl}/planejamento/regiao`
          axios.get(url).then(res => {
            this.regioes = res.data.map(reg => {              
              return { ... reg, value: reg.id_regiao, regiao: reg.regiao  }
            })
          })
        },  






        loadPonto() {                        
            let corpo = {                    
                "id_regiao": `${[this.value_regiao.map(regiao => regiao.id_regiao)]}`                
            };
 
            const url = `${baseApiUrl}/planejamento/ponto`            
            axios.post(url,corpo).then(res => {                                
                this.carregando = false;
                this.pontos = res.data.map(ponto => {
                            return {                              
                              id_empresa: ponto.id_empresa, 
                              id_filial: ponto.id_filial,                               
                              id_ponto: ponto.id_ponto,                               
                              ponto: ponto.ponto,
                              latitude: ponto.latitude, 
                              longitude: ponto.longitude,
                              coordenadas: ponto.coordenadas,
                              id_regiao: ponto.id_regiao,
                              regiao: ponto.regiao,
                              dt_cadastro: ponto.dt_cadastro, 
                              dt_atualizacao: ponto.dt_atualizacao
                            }              
                                                })
                        })            
        }, 


        editPonto(ponto){
            this.ponto = { ...ponto }
        },

        loadRegiaomap(regioes){
            this.regioes = { ...regioes }
        },
        
        postPonto() {                        
        let corpo = {                 
                "id_ponto": `${this.ponto.id_ponto}`,
                "ponto": `${this.ponto.ponto}`,
                "latitude": `${this.ponto.latitude}`,  
                "longitude": `${this.ponto.longitude}`,                  
                "id_regiao": `${this.ponto.id_regiao}`
        };

        const url = `${baseApiUrl}/planejamento/saveponto`   

            axios.post(url,corpo).then(() => {
                    this.$toasted.global.defaultSuccess()
                    //this.reset() limpar os objetos valores
                })
                .catch(showError)
        },

        reset() {            
            this.ponto = {}
            this.loadPonto()            
        }
       
    },



    mounted() {        
        this.loadRegiao()
        this.loadRegiaomap()  
        this.editPonto()
        // this.loadPonto()        se habilitado carrega o grid
    },



}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

#selecaostatusx{
    font-size: 0.7em;      
}

#pontos{   
    font-size: 0.9em;      
    text-align: center;
    
}




</style>